import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  Spinner,
} from 'react-bootstrap';
import SEO from '../../components/seo';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector, login } from '../../store/slices/auth-slice';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const {t} = useTranslation();
  const { isLoading } = useSelector(authSelector);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const onSubmit = (data) => {
    dispatch(
      login({
        ...data,
        navigate,
      })
    );
  };

  return (
    <>
      <SEO titleTemplate={t("Login")} description={t("Login page.")} />
      <Container
        fluid
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: '100vh', backgroundColor: '#ffffff' }}
      >
        <Row className="w-100" style={{ maxWidth: '1200px' }}>
          <Col
            md={6}
            className="d-none d-md-flex align-items-center justify-content-center mb-5 mb-md-0"
          >
            <div className="text-center">
              <img
                src="/assets/img/login_bg1.png"
                alt={("Illustration")}
                className="img-fluid"
                style={{ maxHeight: '450px' }}
              />
            </div>
          </Col>

          {/* Right Side: Login Form */}
          <Col md={5} lg={4} className="mx-auto">
            <Card
              style={{ borderRadius: '10px' }}
              className="custom-shadow-card p-4"
            >
              <Card.Body>
                {/* Logo */}
                <div className="text-center mb-4">
                  <img
                    src="/assets/img/logo/logo.png"
                    alt={t("Logo")}
                    style={{ maxWidth: '120px' }}
                  />
                </div>

                {/* Title */}
                <h2
                  className="mb-4 mt-3"
                  style={{ color: '#9B51E0', fontWeight: 'bold' }}
                >
                  {t("Login")}
                </h2>

                <Form onSubmit={handleSubmit(onSubmit)} noValidate>
                  {/* Username Field */}
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder={t("Username")}
                      style={{ borderRadius: '10px', padding: '25px 15px' }}
                      isInvalid={!!errors.userLoginId}
                      {...register('userLoginId', { required: true })}
                    />
                    {errors.userLoginId && (
                      <div className="text-danger mt-1">
                        {t("Username is required!")}
                      </div>
                    )}
                  </Form.Group>

                  {/* Password Field with SHOW/HIDE Icon */}
                  <Form.Group className="mb-3">
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        placeholder={t("Password")}
                        style={{
                          padding: '25px 15px',
                          borderRadius: '10px 0 0 10px',
                        }}
                        isInvalid={!!errors.password}
                        {...register('password', { required: true })}
                      />
                      <InputGroup.Text
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          borderRadius: '0 10px 10px 0',
                          cursor: 'pointer',
                          backgroundColor: '#fff',
                          border: '1px solid #ced4da',
                        }}
                      >
                        <i
                          className={`fa ${
                            showPassword ? 'fa-eye-slash' : 'fa-eye'
                          }`}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.password && (
                      <div className="text-danger mt-1">
                        {t("Password is required!")}
                      </div>
                    )}
                  </Form.Group>

                   {/* Tenant Field */}
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder={t("Tenant ID")}
                      style={{ borderRadius: '10px', padding: '25px 15px' }}
                      isInvalid={!!errors.tenantId}
                      {...register('tenantId', { required: false })}
                    />
                    {errors.tenantId && (
                      <div className="text-danger mt-1">
                        {t("Tetant is required!")}
                      </div>
                    )}
                  </Form.Group>

                  {/* Remember Me & Forgot Password */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Form.Group controlId="rememberMe" className="mb-0">
                      <Form.Check type="checkbox" label={t("Remember me")} />
                    </Form.Group>
                    {/* <a
                      href="#forgot-password"
                      className="small"
                      style={{ textDecoration: 'none', color: '#9B51E0' }}
                    >
                      Forgot Password?
                    </a> */}
                  </div>

                  {/* Login Button */}
                  <Button
                    type="submit"
                    className="w-100"
                    style={{
                      backgroundColor: '#9B51E0',
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: '500',
                      padding: '15px 0',
                    }}
                    disabled={isLoading}
                  >
                    {isLoading && (
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="mx-2"
                      />
                    )}{' '}
                    {t("Log In")}
                  </Button>
                </Form>

                {/* Sign Up Link */}
                {/* <div className="text-center mt-4">
                  <span>Don&apos;t have an account? </span>
                  <a
                    href="#signup"
                    style={{ color: '#9B51E0', textDecoration: 'none' }}
                  >
                    Sign Up
                  </a>
                </div> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
